module.exports = __webpack_public_path__ + "static/img/home-city-data.486caf8f.jpg";